import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom-v5'
import { Header } from './components/Header/Header'
import { StmAuthProcessing } from './login/AuthProcessing'
import { RefreshStmCosignToken } from './login/RefreshStmCosignToken'
import { StmLogin } from './login/StmLogin'

export const UnauthRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <>
      <Header isAuth={false} />
      <RefreshStmCosignToken />
      <Switch>
        <Route path={`${path}/login`} exact>
          <StmLogin basePath={url} />
        </Route>
        <Route path={`${path}/auth-processing`} exact>
          <StmAuthProcessing basePath={url} />
        </Route>
        <Route path="*">
          <Redirect to={`${url}/login`} />
        </Route>
      </Switch>
    </>
  )
}
